export interface WordPair { id: string; threat: string; neutral: string }
export interface NeutralPair { id: string; a: string; b: string }

export interface WordStimulusSet {
  id: string;
  version: string;
  language: string;
  status: 'validated' | 'placeholder-unverified';
  threatNeutralPairs: WordPair[];
  neutralNeutralPairs: NeutralPair[];
}

/** 자극 텍스트 → 에셋 id. 같은 단어는 같은 비트맵을 쓴다. */
export const wordAssetId = (text: string): string => `w:${text}`;
